module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-periodic-table-options"
  }, [_vm._l((_vm.groups), function(group) {
    return _c('button', {
      staticClass: "btn btn-primary btn-block",
      class: 'btn-' + group,
      attrs: {
        "type": "button"
      },
      on: {
        "mouseover": function($event) {
          _vm.addGroupOnHover(group)
        },
        "mouseout": function($event) {
          _vm.removeGroupOnHover(group)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("element.group." + group)) + "\n\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3"
  }, [_vm._v(_vm._s(_vm.$t("sidebar.simpleView")))]), _vm._v(" "), _c('mdc-switch', {
    model: {
      value: (_vm.simpleView),
      callback: function($$v) {
        _vm.simpleView = $$v
      },
      expression: "simpleView"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4de648c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/PeriodicTableOptions.vue
// module id = 653
// module chunks = 1